import { Component, OnInit, Renderer2, RendererFactory2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController, ModalOptions } from '@ionic/angular';
import { OtpComponent } from './otp/otp.component';
import { OtpService } from '../../services/otp.service';
import { OtpManagerService } from '../../services/otp-manager.service';
import { Router } from '@angular/router';
import { RiderService } from '../../services/rider.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { LOCAL_STORAGE } from '../../constants/local-storage.constants';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private modalCtrl: ModalController,
    private otpManagerService: OtpManagerService,
    private router: Router,
    private localStorage: LocalStorageService,
    private riderService: RiderService,
    private authService: AuthService
  ) {
    this.loginForm = this.fb.group({
      phone: [
        '',
        [
          Validators.required,
          Validators.minLength(10),
          Validators.pattern('^[0-9]*$'),
        ],
      ],
      termsAccepted: [false, Validators.requiredTrue],
    });
  }

  ngOnInit() {
    this.otpManagerService.initializeOtpWidget();
  }

  async getOtp() {
    try {
      if (!this.loginForm.valid) {
        this.loginForm.markAllAsTouched();
        return;
      }
      const fullPhoneNumber = this.patchCountryCode(this.loginForm.value.phone);
      this.otpManagerService.sendOtp(fullPhoneNumber);

      const options: ModalOptions = {
        component: OtpComponent,
        componentProps: {
          phone: this.loginForm.value.phone,
        },
      };
      const modal = this.modalCtrl.create(options);
      (await modal).present();
      (await modal).onDidDismiss().then((data) => {
        if (data.data?.verified) {
          console.log('ondismiss', data.data?.verified);
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  patchCountryCode(phone: string): string {
    const countryCode = '91'; // Replace with dynamic country code logic if needed
    return `${countryCode}${phone}`;
  }
  
}
